import Stack, { type StackProps } from '@mui/material/Stack';
import { styled } from '@mui/system';

export const HeaderInnerStack = styled(Stack)<StackProps>(({ theme }) => ({
  gap: theme.spacing(2),
  flexDirection: 'row',
  paddingInline: '0 1rem ',
  paddingTop: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(1),
    flexDirection: 'column',
    paddingInline: '1rem 0',
    paddingTop: theme.spacing(0),
  },
}));

export const HeaderOuterStack = styled(Stack)<StackProps>(({ theme }) => ({
  width: '100%',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
}));
